import { FormControl, FormGroup, Validators } from "@angular/forms";
import { CriteriaFieldType } from "../../report-form/models/criteria-type-field.model";
import { ReportCriteriaConst } from "../../report-form/report-criteria-form/report-criteria-constants";
import { SharedConstants } from "../../../constants/shared.constants";
export class ReportParametersBuilder {
    ucFirst;
    datePipe;
    reportMetadata;
    myForm;
    reportCriteriaRow = {};
    reportDataInfoRow = {};
    get reportCriteria() {
        return this.myForm.get(ReportCriteriaConst.REPORT_CRITERIA_CONTROL);
    }
    get reportDataInfo() {
        return this.myForm.get(ReportCriteriaConst.REPORT_DATA_INFO_CONTROL);
    }
    constructor(ucFirst, datePipe, reportMetadata, myForm) {
        this.ucFirst = ucFirst;
        this.datePipe = datePipe;
        this.reportMetadata = reportMetadata;
        this.myForm = myForm;
    }
    setReportCriteria(reportCriteriaRow) {
        if (reportCriteriaRow.CriteriaFieldLabel) {
            reportCriteriaRow.CriteriaFieldLabel = this.ucFirst.transform(reportCriteriaRow.CriteriaFieldLabel.toLowerCase());
        }
        this.reportCriteriaRow = reportCriteriaRow;
        const formGroup = this.reportCriteriaFrm();
        this.reportCriteria.push(formGroup);
    }
    reportCriteriaFrm() {
        const form = this.formSetup();
        const control = this.preparValidation();
        form.addControl(ReportCriteriaConst.CRITERIA_FIELD_VALUE_CONTROL, control);
        return form;
    }
    formSetup() {
        const form = new FormGroup({
            CriteriaName: new FormControl(this.reportCriteriaRow.CriteriaName),
            CriteriaFieldLabel: new FormControl(this.reportCriteriaRow.CriteriaFieldLabel),
            CriteriaFieldType: new FormControl(this.reportCriteriaRow.CriteriaFieldType),
            CriteriaFieldComparison: new FormControl(this.reportCriteriaRow.CriteriaFieldComparison),
            CriteriaViewColumn: new FormControl(this.reportCriteriaRow.CriteriaViewColumn),
            CriteriaFieldDefault: new FormControl(this.reportCriteriaRow.CriteriaDefaultValue),
            CriteriaSurveyQuery: new FormControl(this.reportCriteriaRow.CriteriaSurveyQuery),
            CriteriaSurveyMapUrl: new FormControl(this.reportCriteriaRow.CriteriaSurveyMapUrl),
            CriteriaSurveyFeatureLayerUrl: new FormControl(this.reportCriteriaRow.CriteriaSurveyFeatureLayerUrl),
            SurveyLayerName: new FormControl(this.reportCriteriaRow.SurveyLayerName),
            DateFormat: new FormControl(this.reportCriteriaRow.DateFormat),
        });
        return form;
    }
    preparValidation() {
        let control;
        if (this.reportCriteriaRow.CriteriaFieldType === CriteriaFieldType.NumberType) {
            control = this.checkNumeric();
        }
        else if (this.reportCriteriaRow.CriteriaFieldType === CriteriaFieldType.Decimal) {
            control = this.checkDecimal();
        }
        else if (this.reportCriteriaRow.CriteriaFieldType === CriteriaFieldType.DateType) {
            control = this.checkDate();
        }
        else if (this.reportCriteriaRow.CriteriaFieldType ===
            CriteriaFieldType.NonVisualPassToSPOnly ||
            this.reportCriteriaRow.CriteriaFieldType ===
                CriteriaFieldType.NonVisualPassToReportOnly ||
            this.reportCriteriaRow.CriteriaFieldType === CriteriaFieldType.Image) {
            control = this.setDefault(this.reportCriteriaRow.CriteriaDefaultValue);
        }
        else {
            control = this.defaultControl();
        }
        return control;
    }
    checkNumeric() {
        if (this.reportCriteriaRow.CriteriaFieldLabel.toLowerCase() ===
            ReportCriteriaConst.DAY_LBL) {
            return new FormControl(this.reportCriteriaRow.CriteriaFieldValue
                ? this.reportCriteriaRow.CriteriaFieldValue
                : "", [
                Validators.pattern("[0-9]*"),
                Validators.max(31),
                Validators.min(1),
                Validators.required,
            ]);
        }
        else if (this.reportCriteriaRow.CriteriaFieldLabel.toLowerCase() ===
            ReportCriteriaConst.MONTH_LBL) {
            const value = this.reportCriteriaRow.CriteriaFieldValue
                ? this.reportCriteriaRow.CriteriaFieldValue
                : "";
            return new FormControl(value, [
                Validators.pattern("[0-9]*"),
                Validators.max(12),
                Validators.min(1),
                Validators.required,
            ]);
        }
        return new FormControl(this.reportCriteriaRow.CriteriaFieldValue
            ? this.reportCriteriaRow.CriteriaFieldValue
            : "", [Validators.pattern("[0-9]*"), Validators.required]);
    }
    checkDecimal() {
        return new FormControl(this.reportCriteriaRow.CriteriaFieldValue
            ? this.reportCriteriaRow.CriteriaFieldValue
            : "", [
            Validators.pattern(SharedConstants.DECIMAL_VALIDATOR_PATERN),
            Validators.required,
        ]);
    }
    checkDate() {
        const date = this.reportCriteriaRow.CriteriaFieldValue
            ? new Date(this.reportCriteriaRow.CriteriaFieldValue.toString())
            : new Date();
        // NB: the date format in the shared constants doesn't work when using it for the default date
        const dateString = this.datePipe.transform(date, ReportCriteriaConst.DATE_CONST);
        return new FormControl(dateString, [Validators.required]);
    }
    defaultControl() {
        if (this.reportCriteriaRow.CriteriaFieldLabel.toLowerCase() ===
            ReportCriteriaConst.MONTH_LBL &&
            this.reportCriteriaRow.CriteriaFieldType === CriteriaFieldType.StringType)
            return new FormControl(this.reportCriteriaRow.CriteriaDefaultValue
                ? this.reportCriteriaRow.CriteriaDefaultValue
                : "", [
                Validators.required,
                Validators.pattern(ReportCriteriaConst.MONTHS_REGEX),
            ]);
        return new FormControl(this.reportCriteriaRow.CriteriaDefaultValue
            ? this.reportCriteriaRow.CriteriaDefaultValue
            : "", [Validators.required]);
    }
    setDefault(defaultValue) {
        return new FormControl(defaultValue, [Validators.required]);
    }
    setReportDataInfo(reportDataInfoRow) {
        this.reportDataInfoRow = reportDataInfoRow;
        const formGroup = this.reportDataInfoFrm();
        this.reportDataInfo.push(formGroup);
    }
    reportDataInfoFrm() {
        return new FormGroup({
            SQLStoredProcedureName: new FormControl(this.reportDataInfoRow.SQLStoredProcedureName),
            ReportDataSetName: new FormControl(this.reportDataInfoRow.ReportDataSetName),
            Landscape: new FormControl(this.reportDataInfoRow.Landscape),
            SQLViewName: new FormControl(this.reportDataInfoRow.SQLViewName),
            OrderBy: new FormControl(this.reportDataInfoRow.OrderBy),
        });
    }
    initMetadata() {
        for (const reportCriteriaRow of this.reportMetadata.reportCriteria) {
            this.setReportCriteria(reportCriteriaRow);
        }
        for (const reportDataInfoRow of this.reportMetadata.reportDataInfo) {
            this.setReportDataInfo(reportDataInfoRow);
        }
    }
}
